import React from "react";
import { TypeAnimation } from "react-type-animation";
import MovingText from "react-moving-text";
import Button from "@mui/material/Button";
import { useMediaQuery, useTheme } from "@mui/material";
import web_dev_banner from "../../assets/web-dev-banner.svg";

const Carousel = () => {
  const theme = useTheme();
  return (
    <div className="relative">
      <div className="flex flex-col sm:flex-row justify-center w-full relative bg-gradient-to-r from-teal-400 to-yellow-200">
        <div className="w-full sm:w-1/2 md:top-1 lg:top-24 py-10 flex flex-col justify-center">
          <div className="w-full text-lg sm:text-4xl px-10 font-bold poppins-bold text-[#333e49] text-center">
            <MovingText
              type="fadeInFromBottom"
              duration="1000ms"
              delay="0s"
              direction="normal"
              timing="ease"
              iteration="1"
              fillMode="none"
            >
              Transforming Ideas into Digital Reality
            </MovingText>
          </div>
          <div className="w-full text-sm sm:text-lg  px-10 leading-10 sm:leading-[5.5rem] font-notosans text-center text-[#ff5e16] font-semibold">
            {/* Crafting Innovative Websites Tailored to Your Vision */}

            <MovingText
              type="fadeInFromLeft"
              duration="1000ms"
              delay="0s"
              direction="normal"
              timing="ease"
              iteration="1"
              fillMode="none"
            >
              <TypeAnimation
                sequence={[
                  'We Experts in "Web Development"',
                  1000,
                  'We Experts in "Website Design"',
                  1000,
                  'We Experts in "Responsive Design"',
                  1000,
                  'We Experts in "User Experience (UX)"',
                  1000,
                  'We Experts in "Interactive Websites"',
                  1000,
                  'We Experts in "Mobile-Friendly Design"',
                  1000,
                ]}
                wrapper="span"
                speed={50}
                style={{ fontSize: "1em", display: "inline-block" }}
                repeat={Infinity}
              />
            </MovingText>
          </div>
          <p className="px-10 sm:px-10 text-center">
            <Button
              size={
                useMediaQuery(theme.breakpoints.down("sm")) ? "small" : "medium"
              }
              variant="contained"
              href="#contact"
            >
              Free Consultation
            </Button>
          </p>
        </div>
        <div className="w-full sm:w-1/2 flex justify-center">
          <img src={web_dev_banner} className="w-[15rem] sm:w-[30rem] animate-pulse" />
        </div>
      </div>
      {/* <div className="w-full overflow-hidden rotate-180 -mt-[9.2rem]">
        <svg
        className="relative block h-[150px]"
        style={{ "width": "calc(100% + 1.3px)", "fill": "#FFFFFF"}}
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          ></path>
        </svg>
      </div> */}
    </div>
  );
};

export default Carousel;
